import { useApiMutation } from "./use-api-mutation";

export function useSendMfaSettingsEmailCode() {
  return useApiMutation("post", "/auth/mfa/email/settings-code", {
    notify: false,
    mapVariables: (_variables: void) => ({}),
  });
}
